import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "text-left border rounded table-auto" }
const _hoisted_2 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", { class: "border-t border-b bg-primary-dark" }, [
    /*#__PURE__*/_createVNode("th", { class: "p-6 py-4" }, "Name"),
    /*#__PURE__*/_createVNode("th", { class: "p-6 py-4" }, "MIF")
  ])
], -1)
const _hoisted_3 = { class: "p-6 py-2" }
const _hoisted_4 = { class: "p-6 py-2 text-2xl" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("table", _hoisted_1, [
    _hoisted_2,
    _createVNode("tbody", null, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.maneuvers, (maneuver, index) => {
        return (_openBlock(), _createBlock("tr", {
          key: index,
          class: "border-b bg-primary-dark"
        }, [
          _createVNode("td", _hoisted_3, _toDisplayString(maneuver.mif.unFormattedManeuver), 1),
          _createVNode("td", _hoisted_4, _toDisplayString(maneuver.mif.value), 1)
        ]))
      }), 128))
    ])
  ]))
}